<template>
  <div>
    
  
    <v-card class="ma-2" v-if="!display">
      <v-card-text>
        <div class="text-center headline">Anda harus input data PERUSAHAAN terlebih dulu !</div>
      </v-card-text>
    </v-card>
    <v-card class="ma-2" v-if="display">
      <v-card-title  class="teal white--text blinking-text">
        Ijin Usaha <br>
        ( Wajib mengisi data NIB )
        <v-spacer />
        <v-btn  @click.stop="openForm(null)">
          <v-icon left>add</v-icon>
          Tambah
        </v-btn>
      </v-card-title>

      <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="pos3List"
          :items-per-page="10"
          :single-select="true"
          item-key="id"
      >
          <template v-slot:item.jenis_nomor="{item}">
            <v-btn icon color="grey" @click.prevent="getLinkDownload(item.dokumen)" ><v-icon>get_app</v-icon></v-btn>
            {{ item.jenis }} - {{ item.nomor }}
          </template>
          <template v-slot:item.berlaku="{item}">
            {{ getDatefnsFormat(item.berlaku) }}
          </template>
          <template v-slot:item.instansi_pemberi="{item}">
            {{ item.instansi }}
          </template>
          <template v-slot:item.kualifikasi="{item}">
            {{ getKualifikasi(item.kualifikasi) }}
          </template>
          <template v-slot:item.kbli="{item}">            
            <span  v-for="kbItem in item.kbli" :key="kbItem">
              <span v-if="getCheckKbliKode(kbItem)">
                <v-tooltip top color="yellow lighten-3 black--text">
                  <template v-slot:activator="{ on }">
                    <v-chip
                      class="mr-1 mb-1 subtitle-2"
                      color="teal"
                      label dark
                      v-on="on"
                    > 
                      {{ getKbliKode(kbItem) }}
                    </v-chip>     
                    </template>
                  <span>{{ getKbliTip(kbItem) }}</span>
                </v-tooltip>                 
              </span>
            </span>
          </template>
          <template v-slot:item.sbu="{item}">            
              <span  v-for="sbuItem in item.sbu" :key="sbuItem">
                <span v-if="getCheckSbuKode(sbuItem)">
                  <v-tooltip top color="yellow lighten-3 black--text">
                    <template v-slot:activator="{ on }">
                      <v-chip
                        class="mr-1 mb-1 subtitle-2"
                        color="teal"
                        label dark
                        v-on="on"
                      > 
                        {{ getSbuKode(sbuItem) }}
                      </v-chip>     
                      </template>
                    <span>{{ getSbuTip(sbuItem) }}</span>
                  </v-tooltip>                 
                </span>
              </span>
          </template>
          <template v-slot:item.actions="{item}">
              <v-btn icon color="cyan" @click="openForm(item)"> <v-icon>mdi-pencil</v-icon> </v-btn>
              <v-btn icon color="pink" @click="deleteIjinUsaha(item.id)"><v-icon>delete</v-icon></v-btn>
          </template>
      </v-data-table>

    </v-card>

    <v-dialog v-model="dlgIjinUsaha" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">Tambah Ijin Usaha</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form3"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-select
                    :items="itemsIjin"
                    label="Jenis Izin"
                    outlined
                    v-model="jenis"
                    :rules="[rules.required]"
                    @change="jenisIzinSelected()"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Nomor Surat"
                    name="nomor"
                    type="text"
                    outlined
                    v-model="nomor"
                    :rules="[rules.required]"
                  />  
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-menu
                    v-model="menuBerlaku"
                    :close-on-content-click="false"
                    :disabled="ignoreValidateMasaBerlaku()"
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computedDateFormattedDatefns"
                        label="Berlaku Sampai"
                        v-on="on"
                        outlined
                        readonly
                        :rules=[calculateExpire]
                        @click:clear="dateBerlaku = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateBerlaku"
                      @change="menuBerlaku = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Instansi Pemberi"
                    type="text"
                    outlined
                    v-model="instansi"
                    :rules="[rules.required]"
                  />  
                </v-col>
              </v-row>
              
              <v-row>
                <v-col cols="6">
                  <v-file-input 
                    outlined 
                    accept=".jpg,.png,.pdf"
                    label="Dokumen Ijin Usaha"
                    v-model="docIjin"
                    chips
                    :rules="[checkUploadIzinUsaha()]"
                    :placeholder="filenameDokumen"
                    append-icon="get_app"
                    @click:append="getLinkDownload(filenameDokumen)"                 
                  ></v-file-input>
                </v-col>
                
              </v-row>     

              <v-row v-if="jenis === 'SIUP' || jenis === 'NIB' || jenis === 'SBU'">
                <v-col cols="6">
                  <v-select
                    :items="itemsKuali"
                    label="Kualifikasi"
                    outlined
                    v-model="kualifikasi"
                    :rules="[rules.required]"
                  ></v-select>                     
                </v-col>
              </v-row>
              <v-row v-if="jenis === 'SIUP' || jenis === 'NIB'">
                <v-col>
                  <v-autocomplete
                    v-model="selectedKbli"
                    :items="listKBLI"
                    :filter="getKbliFilter"
                    label="KBLI"
                    outlined
                    multiple
                    chips
                    item-value="id"
                    item-text="nama"
                    item-key="id"
                    :rules="[validateKbliSelections()]"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="removeSelectedKbli(data.item)"
                      >
                        {{ data.item.kategori }} - {{ data.item.kode }} - {{ data.item.nama }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content v-text="data.item.kategori + ' - ' + data.item.kode + ' - ' + data.item.nama"></v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="jenis === 'SBU'">
                <v-col>
                  <v-autocomplete
                    v-model="selectedSbu"
                    :items="listSBU"
                    :filter="getSbuFilter"
                    label="SBU"
                    outlined
                    multiple
                    chips
                    item-value="id"
                    item-text="subklasifikasi"
                    item-key="id"
                    :rules="[validateSbuSelections()]"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="removeSelectedSbu(data.item)"
                      >
                        {{ data.item.kode }} - {{ data.item.subklasifikasi }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content v-text="data.item.kode + ' - ' + data.item.subklasifikasi"></v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-textarea v-model="keterangan" label="Keterangan Tambahan" outlined />
                </v-col>
              </v-row>

            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" dark @click="dlgIjinUsahaSimpanClick()">Simpan</v-btn>
          <v-btn color="orange" dark @click="closeForm()">Batal</v-btn>
          <v-btn color="info" dark @click="resetForm3()">Reset</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="loginExpired" max-width="400" persistent>
        <v-card>
            <v-card-title>Login Expired</v-card-title>
                <v-card-text>Silakan Login Ulang</v-card-text>
            <v-card-actions>
                <v-btn color="red" @click="logoutClick()">Ya</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { itemsKualifikasi as kuali, itemsKbli as kblies, itemsJenisIjiin as ijins } from "./../../lib/viewLib"
import axios from 'axios'
import { format, parseISO } from 'date-fns'
import { rules as Rules } from "./../../lib/rules";
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  data: function() {
    return {
      valid: true,
      // ijin usaha
      dlgIjinUsaha: false,
      jenis: '',
      nomor: '',
      instansi: '',
      docIjin: null,
      kualifikasi: '',
      kbli: [],     
      sbu: [],     
      keterangan: "",
      dateBerlaku: "",
      menuBerlaku: false,
      pos3Count: 0,
      pos3List: [],
      izinUsaha: [
        {
          id: 1,
          jenis: 'SIUP',
          nomor: '123',
          berlaku: '2020-12-25',
          instansi: 'PT AAA',
          kualifikasi: 'besar',
          kbli: [ '4510', '4530','4540' ],
          dokumen: 'SKPKP-AndaraUtama-g87jlECU.pdf'
        },
        /* {
          jenis: 'SIUP',
          nomor: '4321',
          berlaku: '15 Des 2020',
          instansi: 'PT ABC',
          kualifikasi: 'menengah',
          kbli: [ '4643' ]
        } */
      ],
      itemsKuali: kuali,
      itemsKbli: kblies,
      itemsIjin: ijins,

      // Table headers
      headers: [
        { text: "Ijin Usaha / No. Surat", value: "jenis_nomor", class: "green accent-2 subtitle-2" },
        { text: "Berlaku Sampai", value: "berlaku", class: "green accent-2 subtitle-2" },
        { text: "Instansi Pemberi", value: "instansi_pemberi", class: "green accent-2 subtitle-2" },
        { text: "Kualifikasi", value: "kualifikasi", class: "green accent-2 subtitle-2" },
        { text: "KBLI", value: "kbli", class: "green accent-2 subtitle-2" },
        { text: "SBU", value: "sbu", class: "green accent-2 subtitle-2" },
        { text: "", value: "actions", sortable: false, class: "green accent-2 subtitle-2" },
      ],
      listKBLI: [],
      listSBU: [],
      rules: {
          required: Rules.required,
      },
      isEditing: false,
      editId: null,
      filenameDokumen: "",
      selectedKbli: [],
      selectedSbu: [],
      dialogEverOpened: false,
      submitting: false,
      loginExpired:false
    }
  },
  methods: {
    getKbliFilter(item, queryText) {
      const kodeLowerCase = item.kode.toLowerCase();
      const namaLowerCase = item.nama.toLowerCase();
      const queryLowerCase = queryText.toLowerCase();
      return kodeLowerCase.indexOf(queryLowerCase) > -1 || namaLowerCase.indexOf(queryLowerCase) > -1;
    },

    getSbuFilter(item, queryText) {
      const kodeLowerCase = item.kode.toLowerCase();
      const namaLowerCase = item.subklasifikasi.toLowerCase();
      const queryLowerCase = queryText.toLowerCase();
      return kodeLowerCase.indexOf(queryLowerCase) > -1 || namaLowerCase.indexOf(queryLowerCase) > -1;
    },

    ignoreValidateMasaBerlaku: function() {
      // return (this.jenis === null || this. jenis === "" || this.jenis === "SIUP" || this.jenis === "NIB" || this.jenis === "PKP");
    },
    jenisIzinSelected: function() {
      if (this.ignoreValidateMasaBerlaku()) {
        //console.log("Jenis Izin selected. Ignore masa berlaku validation");
        this.$refs.form3.resetValidation();
        this.dateBerlaku = new Date().toISOString().substr(0, 10);
      }
    },
    calculateExpire: function() {
      //console.log("Jenis: ", this.jenis);
      if (this.ignoreValidateMasaBerlaku()) return true;

      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const nowDate = new Date();
      const diffDays = Math.round((parseISO(this.dateBerlaku) - nowDate) / oneDay);
      return diffDays>=this.$store.getters.MASA_BERLAKU_SIUP || `Masa berlaku Ijin Usaha minimal ${this.$store.getters.MASA_BERLAKU_SIUP} hari`
    },
    checkUploadIzinUsaha: function() {
      if (this.isEditing && this.filenameDokumen != "") return true;
      return this.docIjin != null || `Hasil scan dokumen Ijin Usaha harus dilampirkan`;
    },
    validateKbliSelections: function() {
      //console.log("Selected KBLI: ", this.kbli);
      if (this.jenis == "SIUP" || this.jenis === "SIUJK" || this.jenis === "NIB") {
        if (this.selectedKbli.length == 0) return "Field harus diisi";
        // if (this.selectedKbli.length > 3) return "Pemilihan KBLI maksimal 3 jenis";  // disable karena jumlah KBLI jadinya tidak dibatasi
      }

      return true;
    },
    validateSbuSelections: function() {
      //console.log("Selected KBLI: ", this.kbli);
      if (this.jenis == "SBU") {
        if (this.selectedSbu.length == 0) return "Field harus diisi";
        // if (this.selectedKbli.length > 3) return "Pemilihan KBLI maksimal 3 jenis";  // disable karena jumlah KBLI jadinya tidak dibatasi
      }

      return true;
    },
    resetForm: function() {
      this.editId = null;
      this.jenis = "";
      this.nomor = "";
      this.dateBerlaku = "";
      this.instansi = "";
      this.kualifikasi = "";
      //this.kbli = [];
      this.keterangan = "";
      this.filenameDokumen = "";
      this.selectedKbli = [];

      if (this.dialogEverOpened) this.$refs.form3.reset();
    },
    openForm: function(item) {
      console.log('item', item);
      this.resetForm();

      if (item) {
        this.jenis = item.jenis;
        this.nomor = item.nomor;
        this.dateBerlaku = item.berlaku;
        this.instansi = item.instansi;
        this.kualifikasi = item.kualifikasi;
        this.filenameDokumen = item.dokumen;
        //this.kbli = item.kbli;
        this.keterangan = item.keterangan;
        this.selectedKbli = item.kbli.slice(0);
        this.selectedSbu = item.sbu.slice(0);
        console.log('this.selectedKbli', this.selectedKbli);
        console.log('this.selectedSbu', this.selectedSbu);
        this.isEditing = true;
        this.editId = item.id;
      }

      this.dlgIjinUsaha = true;
      this.dialogEverOpened = true;
    },
    closeForm: function() {
      this.resetForm();
      this.dlgIjinUsaha = false;
      this.isEditing = false;
    },
    dlgIjinUsahaSimpanClick: async function() {
      if (!this.$refs.form3.validate()) {
        return null
      }

      this.kbli = this.selectedKbli.slice(0);
      this.sbu = this.selectedSbu.slice(0);

      let newIjin = {
        id: null,
        jenis: this.jenis,
        nomor: this.nomor,
        berlaku: this.dateBerlaku,
        instansi: this.instansi,
        kualifikasi: this.kualifikasi,
        kbli: this.kbli,
        sbu: this.sbu,
        keterangan: this.keterangan,
        dokumen: ''
      };
      
      const fdata = new FormData()
      fdata.append('jenis', this.jenis)
      fdata.append('nomor', this.nomor)
      fdata.append('berlaku', this.dateBerlaku)
      fdata.append('instansi', this.instansi)
      fdata.append('kualifikasi', this.kualifikasi)
      fdata.append('kbli', this.kbli.toString())
      fdata.append('sbu', this.sbu.toString())
      fdata.append('keterangan', this.keterangan)

      if (this.docIjin) {
        fdata.append('dokumen', this.docIjin)
      }

      fdata.append('vendorId', this.venId)
      // simpan ke database
      this.$store.dispatch('displayProgBar');

      if (this.isEditing) {
        this.submitting = true;

        axios.put(apiUrl + '/vendor/ijinusaha/' + this.editId, fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
        .then((response) => {
          console.log(`New update ijin usaha ${this.editId}: ${response.data}`);
          console.log(response.data);

          this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Data ijin usaha telah diperbarui!` 
          });

          //this.$store.dispatch('ven/assignVendor', response.data.data)
          //this.$store.commit('reg/setStatusPengurus', 'V')
          window.scroll(0,0)

          const index = this.pos3List.findIndex(element => { return element.id === this.editId; });
          //console.log("Update data at index: ", index);
          if (index != -1) {
            this.pos3List.splice(index, 1);
            newIjin.id = this.editId;
            newIjin.dokumen = response.data.dokumen;
            this.pos3List.push(newIjin);
          }
          //console.log(this.pos3List);

        })
        .catch((error) => {
          if(error.response.status == 401) {
            this.loginExpired = true;
          }else if(error.response.status == 422) {
            this.loginExpired = true;
          }else {
            this.$store.dispatch('displayAlert', {color: 'error', message: `Gagal update! ${error.response.data.message}`})
            window.scroll(0,0)
          }
        })
        .finally(() => {
          this.$store.dispatch('closeProgBar')
          this.submitting = false;
        });  

      } else {
        this.submitting = true;

        axios.post(apiUrl + '/vendor/registrasi/ijinusaha', fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
        .then((response) => {
          this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Data ijin usaha telah tersimpan !` 
          });
          
          this.$store.dispatch('ven/assignVendor', response.data.data)
          this.$store.commit('reg/setStatusIjin', 'V')
          window.scroll(0,0)

          

          // update datatable
          newIjin.id = response.data.data.ijinId
          newIjin.dokumen = response.data.data.dokumen
          this.pos3List.push(newIjin)
          this.pos3Count = this.pos3List.length
        })
        .catch((error) => {
          if(error.response.status == 401) {
            this.loginExpired = true;
          }else if(error.response.status == 422) {
            this.loginExpired = true;
          }else {
            this.$store.dispatch('displayAlert', {color: 'error', message: `Gagal menyimpan! ${error.response.data.message}`})
            window.scroll(0,0)
          }
        })
        .finally(() => {
          this.$store.dispatch('closeProgBar')
          this.submitting = false;
        });     

      }
      
      this.closeForm();

    },
    resetForm3: function() {
      this.$refs.form3.reset() 
    },
    simpan3Click: async function() {
      if (this.pos3Count == 0) {
        this.alertMsg = "Proses Lanjut GAGAL - Anda harus melampirkan minimal 1 surat ijin !"
        this.alertColor = "error"
        this.alert = true
      }
      else {
        const message = {        
          posisi: this.posisi,   
          email: this.emailR,
          kodeUrl: this.kodeUrl
        };
        this.loading = true;
        await axios.post(apiUrl + 'vendor/ijinusaha/next', message)
        .then((response) => {
          this.posisi = response.data.data.tahap
          this.password = 'NaN',
          this.passwordKonfirmasi = 'NaN'
        })
        .catch((err) => {
          this.alertMsg = "Error untuk melanjutkan registrasi ! Silahkan coba beberapa saat lagi - " + err
          this.alertColor = "error"
          this.alert = true
        })
        .finally(() => {
          this.loading = false
        })    
      }
    },
    deleteIjinUsaha: async function(id) {
      // hapus database
      this.submitting = true;

      axios.delete(apiUrl+`/vendor/ijinusaha/${id}`)
      .then((response) => {
        if (response.data.statusCode != 200) { // hapus gagal
          this.$store.dispatch('displayAlert', {color: 'error', message: 'Error dalam penghapusan data ! Silahkan coba beberapa saat lagi' })
          window.scroll(0,0)
        }
        else { // hapus berhasil
          // hapus element data table
          this.pos3List = this.pos3List.filter(function(el) {
            return el.id !== id;
          });
          this.pos3Count = this.pos3List.length;
        }
      })
      .catch((error) => {
        console.log(error)
        this.$store.dispatch('displayAlert', {color: 'error', message: 'Error dalam penghapusan data ! Silahkan coba beberapa saat lagi' })
      })     
      .finally( () => {
        this.submitting = false;
      })
    },
    // Table Preformat Data
    getKbliKode: function(id) {
      console.log("Get KBLI kode: ", id);
      const found = this.listKBLI.find(element => element.id == id);
      return found ? found.kode : '';
    },
    // Table Preformat Data
    getCheckKbliKode: function(id) {
      console.log("Get KBLI kode: ", id);
      const found = this.listKBLI.find(element => element.id == id);
      return found ? true : false;
    },
    getKbliTip: function(id) {
      console.log("Get KBLI tip: ", id);
      const found = this.listKBLI.find(element => element.id == id);
      return found ? found.nama : '-';
    },
    getSbuKode: function(id) {
      console.log("Get SBU kode: ", id);
      const found = this.listSBU.find(element => element.id == id);
      return found ? found.kode : '';
    },
    getSbuTip: function(id) {
      console.log("Get SBU tip: ", id);
      const found = this.listSBU.find(element => element.id == id);
      return found ? found.subklasifikasi : '-';
    },
    // Table Preformat Data
    getCheckSbuKode: function(id) {
      const found = this.listSBU.find(element => element.id == id);
      return found ? true : false;
    },
    getKualifikasi: function(val) {
      console.log("Get kualifikasi: ", val);
      if (val == null || val === "") return "";
      return kuali.find(({value}) => value === val).text
    },
    getDatefnsFormat: function(date) {
      return format(parseISO(date), "dd MMM yyyy")
    },
    getLinkDownload: function(dok) {
      axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    getDateFormattedDatefns: function(date) {
      return date ? format(parseISO(date), "dd MMM yyyy") : ''
    },
    removeSelectedKbli(item) {
      //console.log("Remove selected KBLI: ", item);
      //console.log("From list: ", this.selectedKbli);
      const index = this.selectedKbli.findIndex(element => element === item.id);
      if (index >= 0) this.selectedKbli.splice(index, 1);
    },
    removeSelectedSbu(item) {
      const index = this.selectedSbu.findIndex(element => element === item.id);
      if (index >= 0) this.selectedSbu.splice(index, 1);
    },
    logoutClick: function() {
        this.$store.dispatch('logout')
        .then(() => {
            this.$router.push('/')
        })
    }
  },
  computed: {
    display: function() {
      return this.$store.getters['ven/venId'] != -999
    },
    venId: function() { 
      return this.$store.getters['ven/venId']
    },
    computedDateFormattedDatefns () {
      return this.dateBerlaku ? format(parseISO(this.dateBerlaku), "dd MMM yyyy") : ''
    },
  },
  created: async function() {
    await axios.get(`${apiUrl}/kbli`)
    .then( (response) => {
      this.listKBLI = response.data;
    });

    await axios.get(`${apiUrl}/sbu`)
    .then( (response) => {
      this.listSBU = response.data;
    });

    this.$store.dispatch('displayPageTitle', 'Ijin Usaha')
    await axios.get(apiUrl+'/vendor/ijinusaha/'+this.venId)
    .then((response) => {
      //console.log("Response IjinUsaha: ", response.data);
      if (response.data.statusCode != 200) {
        this.pos3List = []
      }
      else {
        response.data.data.forEach(element => {
          let tmpkode = element.kbli.split(',')
          let tmpkbli = []
          tmpkode.forEach(val => {
            tmpkbli.push(Number(val));
          })
          element.kbli = tmpkbli
          //console.log("element kbli: ", element.kbli);

          let tmpSbuKode= element.sbu.split(',')
          let tmpSbu = []
          tmpSbuKode.forEach(val => {
            tmpSbu.push(Number(val));
          })
          element.sbu = tmpSbu

          this.pos3List.push(element)
        })              
      }
      
      this.pos3Count = this.pos3List.length
    })
    .catch((error) => {
      console.log(error)
    });
  }
}
</script>

<style>

</style>